export const CommonRoutes = {
    LOGIN: '/login',
    RESET_PASSWORD: '/reset-password',
    NEW_PASSWORD: '/reset-password/new-password/:email/:role/:token',
    NEW_PASSWORD_TAIL: '/reset-password/new-password/:email/:role/:token/:tail',

    PROFILE: '/profile',
    PROFILE_EDIT: '/profile/:id/edit',

    ACCOUNT: '/account',

    DASHBOARD: '/dashboard',

    ADVERTISER: '/adv',
    ADVERTISER_CREATE: '/adv/create',
    ADVERTISER_EDIT: '/adv/:id/edit',
    ADVERTISER_COPY: '/adv/:id/copy',


    CAMPAIGN: '/campaign',
    CAMPAIGN_CREATE: '/campaign/create',
    CAMPAIGN_EDIT: '/campaign/:id/edit',
    CAMPAIGN_COPY: '/campaign/:id/copy',

    AD_GROUP: '/ad-group',
    AD_GROUP_CREATE: '/ad-group/create',
    AD_GROUP_COPY: '/ad-group/:id/copy',
    AD_GROUP_EDIT: '/ad-group/:id/edit/:activeTab?',

    CREATIVE: '/creative',
    CREATIVE_CREATE: '/creative/create',
    CREATIVE_EDIT: '/creative/:id/edit',
    CREATIVE_COPY: '/creative/:id/copy',

    REPORT_BUILDER: '/report-builder',
    REPORT: '/report',
    REPORT_OPEN: '/report/:id',
    REPORT_EDIT: '/report/:id/edit',
    REPORT_COPY: '/report/:id/copy',

    FILTER_LIST: '/filter-list',
    FILTER_LIST_CREATE: '/filter-list/create',
    FILTER_LIST_EDIT: '/filter-list/:id/edit',

    FILTER_LIST_GLOBAL: '/filter-list-global',
    FILTER_LIST_GLOBAL_CREATE: '/filter-list-global/create',
    FILTER_LIST_GLOBAL_EDIT: '/filter-list-global/:id/edit',

    SUPPORT: '/support',
    MAINTENANCE: '/maintenance',
    INFORM: '/inform',

    SSP: '/ssp',
    SSP_CREATE: '/ssp/create',
    SSP_COPY: '/ssp/copy',

    PUBLISHER: '/publishers',
    PUBLISHER_CREATE: '/publishers/create',

    SITE: '/sites',
    SITE_CREATE: '/sites/create',

    AD_UNIT: '/ad-units',
    AD_UNIT_CREATE: '/ad-units/create',

    AD_SIZE: '/ad-sizes',
    AD_SIZE_CREATE: '/ad-sizes/create',

    DEAL: "/deals",
    DEAL_CREATE: "/deals/create",

    TRACKER: '/tracker',
    TRACKER_CREATE: '/tracker/create',
    TRACKER_EDIT: '/tracker/:id/edit',

    TRACKER_EVENT_STATS: '/tracker-event-stats',
    TRACKER_EVENT_REPORT: '/tracker-event-report',
    TRACKER_EVENT_REPORT_CREATE: '/tracker-event-report/create',
    TRACKER_EVENT_REPORT_OPEN: '/tracker-event-report/:id',
    TRACKER_EVENT_REPORT_EDIT: '/tracker-event-report/:id/edit',
    TRACKER_EVENT_REPORT_COPY: '/tracker-event-report/:id/copy',

    TRACKER_EVENT: '/tracker-event',
    TRACKER_EVENT_CREATE: '/tracker-event/create',
    TRACKER_EVENT_EDIT: '/tracker-event/:id/edit',

    RETARGETING_LIST: '/retargeting-list',
    RETARGETING_LIST_OPEN: '/retargeting-list/:id',

    CONTEXTUAL_TARGETING: '/contextual-targeting',

}

const routeTitleAliases: Record<string, string> = {
    [CommonRoutes.PROFILE]: 'Profile',
}

const routeActionTitleAliases: Record<string, string> = {
    [CommonRoutes.PROFILE]: 'Profile',
    [CommonRoutes.ACCOUNT]: 'Account',
    [CommonRoutes.ADVERTISER]: 'Advertiser',
    [CommonRoutes.CAMPAIGN]: 'Campaign',
    [CommonRoutes.AD_GROUP]: 'Ad Group',
    [CommonRoutes.CREATIVE]: 'Creative',
    [CommonRoutes.REPORT]: 'Saved Report',
    [CommonRoutes.FILTER_LIST]: 'Filter List',
    [CommonRoutes.FILTER_LIST_GLOBAL]: 'Global Filter',
    [CommonRoutes.TRACKER]: 'Tracker',
    [CommonRoutes.TRACKER_EVENT_REPORT]: 'Tracker Report',
    [CommonRoutes.RETARGETING_LIST]: 'Retargeting List',
    [CommonRoutes.CONTEXTUAL_TARGETING]: 'Contextual Targeting',
    [CommonRoutes.PUBLISHER]: 'Publisher',
    [CommonRoutes.SITE]: 'Site',
    [CommonRoutes.AD_UNIT]: 'Ad Unit',
    [CommonRoutes.DEAL]: 'Deal',
}

const selectedMenuKeyAliases: Record<string, string> = {}

export function getRouteTitleAlias(pathname: string): string | undefined {
    return routeTitleAliases[pathname]
}

export function getRouteActionTitleAlias(pathname: string): string | undefined {
    return routeActionTitleAliases[pathname]
}

export function getRouteActionTitle(pathname: string, fallback: string): string {
    return getRouteActionTitleAlias(pathname) || fallback
}

export function normalizeRoutePath(path: string): string {
    if (!path) {
        return ''
    }
    return path.startsWith('/') ? path : `/${path}`
}

export function getBaseRoute(pathname: string): string {
    const normalizedPath = normalizeRoutePath(pathname)
    const [section] = normalizedPath.split('/').filter(Boolean)
    return section ? `/${section}` : CommonRoutes.DASHBOARD
}

export function normalizeSelectedMenuKey(pathname: string): string {
    const baseRoute = getBaseRoute(pathname)
    return selectedMenuKeyAliases[baseRoute] || baseRoute
}
